export const MenuTips = [
    {
      title: 'JOB SEARCH STRATEGY',
      path: '/LOCATION',
      cName: 'dropdown-link'
    },
    {
      title: 'RESUME & COVER LETTER',
      path: '/SKILLS',
      cName: 'dropdown-link'
    },
    {
      title: 'INTERVIEW TIPS',
      path: '/INDUSTRY',
      cName: 'dropdown-link'
    },
    {
      title: 'CAREER MANAGEMENT',
      path: '/COMPANY',
      cName: 'dropdown-link'
    }
  ];
  